/* -------------------------------------------

	Name:		5070
	Date:		2023/07/03

---------------------------------------------  */
/*global jQuery, document, window, yall, setTimeout */
// Loop index renamed from a global `i`: another script on the page declares a global `let i`, which made this whole file throw on load.
var img_lazy = document.querySelectorAll('img[data-src]:not(.dont)'),
	isMobile = false;
for (var lazyIdx5070 = 0; lazyIdx5070 < img_lazy.length; lazyIdx5070 = lazyIdx5070 + 1) {
	img_lazy[lazyIdx5070].classList.add('lazy');
}

function isTouchDevice() {
	"use strict";
	if (window.matchMedia("(pointer: coarse)").matches) {
		return true;
	} else {
		return false;
	}
}
if (window.mobileCheck() || isTouchDevice()) {
	isMobile = true;
}
document.addEventListener('DOMContentLoaded', function () {
	'use strict';
	yall({
		observeChanges: true,
		threshold: 500
	});
});
jQuery(function () {
	"use strict";
	var
		$ = jQuery.noConflict(),
		html_tag = document.documentElement,
		select_tag = $(document.getElementsByTagName('select')),

		footer_id = document.getElementById('footer'),
		footer_date = footer_id ? footer_id.querySelectorAll('.date') : [],

		email_tag = document.getElementsByClassName('email'),
		list_collection = $(document.getElementsByClassName('list-collection')),
		list_collections = $(document.getElementsByClassName('list-collections')),
		list_product = $(document.getElementsByClassName('list-product')),
		module_featured = $(document.getElementsByClassName('module-featured')),
		module_list_slider = $(document.getElementsByClassName('module-list-slider')),
     

		Default = {
			utils: {
				mails: function () {
					if (email_tag.length) {
						Array.from(email_tag).filter(function (el) {
							return el.tagName.toLowerCase() !== 'input' && el.tagName.toLowerCase() !== 'div';
						}).forEach(function (el) {
							el.innerText = el.innerText.replace('//', '@').replace(/\//g, '.');
							if (el.tagName.toLowerCase() === 'a') {
								el.setAttribute('href', 'mailto:' + el.innerText);
							}
						});
					}
				},
				layout: function () { 
					$('.searchContainer a').on('click', function(e) {
						e.preventDefault();
						$('.searchContainer form').toggleClass('hidden');
                        $('#logo').toggleClass('mobile-hide');
						return false;
					})
				},
				date: function () {
					if (footer_date.length) {
						footer_date[0].innerText = (new Date()).getFullYear();
					}
				},
				mobile: function () {
					if (isMobile) {
						html_tag.classList.add('mobile');
					} else {
						html_tag.classList.add('no-mobile');
						if (select_tag.length) {
							// $(select_tag).semanticSelect();
						}
					}
				},
				done: function () {
					var tag = document.createElement('script');
					tag.src = scripts_async_url;
					document.body.appendChild(tag);
				},
				shopify: function () { 

                    
						/************************ CART */

						/**
						 * Activate 'remove' links from cart after refresh
						 */
						function initRemoveItem() { 
							$('.table-cart .remove').on('click', function(e) { 
								e.preventDefault();
		
								var str_variant_id = $(this).attr('data-variant-id');
								var variant_id = parseInt(str_variant_id);
								
								Shopify.removeItem(variant_id, function() {
									refreshCart();
								});
								
								return false;
							});
						}
						initRemoveItem();
	
						/**
						 * Get custom image from shopify's CDN
						 */
						function getImageWithCustomRatio(src_image, params) {
							var imageArr = src_image.split('.');
							var location = imageArr.length - 2;
							var oldStr = imageArr[location];
							imageArr[location] = oldStr + params;
							var imageWithCustomRatio = imageArr.join('.');
							return imageWithCustomRatio;
						}

						// update cart values from .input-amount
						// function updateCartValues() {
            //   $('.list-cart .input-amount a').on('click', function() {
            //       var input = $(this).parent().children('input');
            //       input.css({ 'opacity': '0.5' });

            //       var quantity = input.val(),
            //       line = input.attr('data-index');

            //       fetch('/cart/change.js', {
            //           method: 'POST',
            //           headers: {
            //               'Content-Type': 'application/json'
            //           },
            //           body: JSON.stringify({ 'quantity': quantity, 'line': line })
            //       })
            //       .then(response => {
            //           refreshCart();
            //           console.log(response);
            //       })
            //       .catch((error) => {
            //           console.error('Error:', error);
            //       });

            //       return false;
            //   });
						// }
						// updateCartValues();

						$('#cart').on('submit', function(e) {
							e.preventDefault();
							window.location.href = '/checkout';  
						})

						/**
						 * Refresh Cart function
						 */
						window.refreshCart = function() {

							$.getJSON("/cart.js", function(json) {
								$('#cartIcon').html('<span>'+json.item_count+'</span>');
								$('.table-cart tr').remove(); // clean old items

								var itemsArr = [];
								// console.log(json);
								
								if (json.item_count > 0) {
                                    $('.table-cart').append(
                                        '<tr>'+
                                            '<td class="strong">מוצר</td>'+
                                            '<td class="strong">סה"כ</td>'+
                                            '<td></td>'+
                                        '</tr>'
                                    );
  
                                  
									// update .tablet-cart
									var index = 1;
									json.items.forEach(item => {

										// Item Options String
										var optionsString = "<p>";
										if (item.product_has_only_default_variant == false) {
											item.options_with_values.forEach(option => {
												optionsString += option.name + " - " + option.value + "</p><p>";
											});
										}
										optionsString += "</p>";

										// Item Options String
										var propsString = '';
										if (item.properties['מסגור עבור']) {
											propsString = '<p>מסגור: ' + item.properties['מסגור עבור'] + '</p>';
										}
										// console.log(propsString);

										itemsArr.push(item.id);
										
										// Item Image
										var cart_item_image_dekstop = 'https://via.placeholder.com/160x160';
										if (item.image){ 
											cart_item_image_dekstop = getImageWithCustomRatio(item.image, '_320x320');
										}

										// item link
										var itemLink = "#";
										if (item.product_title.toLowerCase().indexOf("תוספת") === -1) { 
											itemLink = item.url;
										}

										// append item to .list-cart
										$('.table-cart').append(
											'<tr>'+
												'<td><div class="module-cart-img">'+
												'<figure><a href="'+itemLink+'"><img src="'+cart_item_image_dekstop+'" alt="'+item.title+'" width="160" height="160"></a></figure>'+
													'<div><h3><span class="small">'+item.vendor+'</span><a href="'+itemLink+'">'+item.product_title+'</a></h3>'+
													optionsString+propsString+
													'<p>מחיר: '+Shopify.formatMoney(item.price, '{{amount_no_decimals}} ₪')+'</p><p>כמות: '+item.quantity+'</p>'+
												'</div></div></td>'+
												'<td class="strong">'+Shopify.formatMoney(item.line_price, '{{amount_no_decimals}} ₪')+'</td>'+
												'<td><a href="./" class="overlay-gray remove" data-variant-id="'+item.variant_id+'"><i aria-hidden="true" class="icon-x"></i> <span class="hidden">Remove</span></a></td>'+
											'</tr>'
										);
										index++;                  
									});
									initRemoveItem(); // enable remove

									// Total value
									// $('#cart .list-total #cartSubtotal').html('<span>סכום ביניים: </span>'+Shopify.formatMoney(json.original_total_price, '{{amount_no_decimals}} ₪'));
									// $('#cart .list-total #cartDiscounts').html('<span>הנחות ומבצעים: </span>'+Shopify.formatMoney(json.total_discount, '{{amount_no_decimals}} ₪'));
									// $('#cart .list-total #cartAfterDiscounts').html('<span>סה״כ אחרי הנחות ומבצעים: </span>'+Shopify.formatMoney(json.total_price, '{{amount_no_decimals}} ₪'));
									$('#cart .list-total #cartTotal').html('סה״כ לתשלום: <span class="size-28">'+Shopify.formatMoney(json.total_price, '{{amount_no_decimals}} ₪')+'</span>');

									// show checkout + note + footer
									$('#cart').removeClass('empty');

								} else { 
									// empty icon
									$('#cartIcon').html('');

									// empty placeholder
									$('.table-cart').append(
										'<tr><td><p class="text-center">עגלת הקניות שלכם ריקה</p></td></tr>'
									);

									// remove total
									$('#cart #cartTotal').html('');

									// hide checkout + note + footer
									$('#cart').addClass('empty');
								}
							});
						}
						window.refreshCart(); 
                  
					if ($('.module-product').length) { 

						let activeSize = '';
						var allFrameOptions = $('select#frameMaterial option').clone();

						
						// --- Mobile collapsible description (5070) ---
						function initMobileDescCollapse() {
						if (window.innerWidth > 767) return;

						var $header = $('.module-product header').first();
						if (!$header.length) return;

						// description block on your page is: <header> ... <div dir="rtl">...</div> </header>
						var $desc = $header.children('div[dir="rtl"]').first();
						if (!$desc.length) return;

						// don't run twice
						if ($desc.parent().hasClass('mobile-desc-wrap')) return;

						// wrap for collapsing
						$desc.wrap('<div class="mobile-desc-wrap"></div>');

						// add toggle button under price (p.strong exists in your header)
						if (!$header.find('.mobile-desc-toggle').length) {
							$('<button type="button" class="mobile-desc-toggle">קראו עוד</button>')
							.insertAfter($header.find('p.strong').first());
						}

						function setOpen(isOpen) {
							$header.toggleClass('is-desc-open', !!isOpen);
							$header.find('.mobile-desc-toggle').text(isOpen ? 'סגור' : 'קראו עוד');
						}

						// default: closed
						setOpen(false);

						// toggle click
						$header.on('click', '.mobile-desc-toggle', function () {
							setOpen(!$header.hasClass('is-desc-open'));
						});

						// when choosing size/frame - close
						$('select#size, select#frameMaterial').on('change', function () {
						setOpen(false);

						var topPos = $header.offset().top - 10;
						$('html, body').scrollTop(topPos);
						});

						// when scrolling back near top - close
						var scrollTimer = null;
						$(window).on('scroll', function () {
							if (scrollTimer) return;
							scrollTimer = setTimeout(function () {
							scrollTimer = null;
							if (window.scrollY < 40) setOpen(false);
							}, 150);
						});
						}

						initMobileDescCollapse();


						function detectSize() {
							var val = $('select#size').val();
							metaData['variants'].forEach((variant) => {
								if (variant['id'] == val) {
									if (variant['available'] == false) { 
										$('button#singleAddToCart').attr('disabled', true);
										$('button#singleAddToCart').text('לא במלאי');
									} else {
										$('button#singleAddToCart').attr('disabled', false);
										$('button#singleAddToCart').text('הוספה לסל');
									}
									// $('#variantPrice').text(Shopify.formatMoney(variant['price'], '{{amount_no_decimals}} ש"ח'))
									$('input[name=id]').val(variant['id']);
									$('#finalPrice').attr('data-artwork', Shopify.formatMoney(variant['price'], '{{amount_no_decimals}}'));
									console.log('chosen: ',variant['id']);
								}
							});
							activeSize = $('select#size option:selected').attr('data-size');
							hideShowFramingOptions();
							detectMatchingSelectedOptions();
							updateFinalPrice();
						}
						$('select#size').on('change', function() {
							detectSize();	
						})
						detectSize();

						// hide mockup images from gallery (owl slide wrapper)
						$('ul.list-product.is-slider img[alt^="mockup|"]').each(function() {
						$(this).closest('.owl-item').hide();
						});

						// hide mockup thumbnails in pager
						$('.pager.custom a img[alt^="mockup|"]').each(function() {
						$(this).closest('li').hide();
						});

						function detectMatchingSelectedOptions() {
							var activeSize = $('select#size option:selected').attr('data-size');
							// framing options
							var isFramingSelected = $('#withFrameYes:checked');
							if (isFramingSelected.length > 0) { 
								var selectedOption = $('select#frameMaterial option:selected');
								if (selectedOption) {
									var selectOptionText = $(selectedOption).text();
									var matchingFramingOption = $('select#frameMaterial option[data-size='+activeSize+']:contains('+selectOptionText+')');
									if (matchingFramingOption) { 
										$('select#frameMaterial').val($(matchingFramingOption).val());
										$('select#frameMaterial').trigger('change');
									}
								}
							}
							// paspartu
							var paspartuStatus = $('#addPaspartu').is(':checked');
							if (paspartuStatus) {
								var paspartuOption = $('ul#paspartu').find('li[data-size='+activeSize+']')[0];
								$('input[name=paspartuID]').val($(paspartuOption).attr('data-value'));
								// $('#paspartuPrice').removeClass('hidden').find('span').text(Shopify.formatMoney($(paspartuOption).attr('data-price'), '{{amount_no_decimals}} ש"ח'));
								$('#finalPrice').attr('data-paspartu', Shopify.formatMoney($(paspartuOption).attr('data-price'), '{{amount_no_decimals}}'));
								updateFinalPrice();
							}
						}

						function updateFinalPrice() { 
							var finalPrice = $('#finalPrice').attr('data-artwork'),
								framingPrice = $('#finalPrice').attr('data-framing'),
								paspartuPrice = $('#finalPrice').attr('data-paspartu'),
								price = parseFloat(finalPrice);
							if (finalPrice && !framingPrice && !paspartuPrice) { 
								price = parseFloat(finalPrice);
							} 
							if (finalPrice && framingPrice && !paspartuPrice) { 
								price = parseFloat(finalPrice) + parseFloat(framingPrice);
							}
							if (finalPrice && framingPrice && paspartuPrice) { 
								price = parseFloat(finalPrice) + parseFloat(framingPrice) + parseFloat(paspartuPrice);
							}
							$('#finalPrice span').text(price + ' ש"ח');
						}

						function resetFramingOptions() {
							$('select#frameMaterial').val([]);
							$('#framePrice').addClass('hidden').find('span').text('');
							$('input[name=frameID]').val('');
							$('#addPaspartu').prop('checked', false);
							$('input[name=paspartuID]').val('');
							$('#paspartuPrice').addClass('hidden').find('span').text('');
							$('#finalPrice').attr('data-framing', '')
							$('#finalPrice').attr('data-paspartu', '');
						}

						$('input[name="withFrame"]').on('change', function() {
							var frameOption = $('input[name="withFrame"]:checked').attr('id');
							if (frameOption == 'withFrameYes') { 
								$('p.withFrameContainer').removeClass('no-frame'); 
								$('select#frameMaterial').val([]);
							} else {
								$('p.withFrameContainer').addClass('no-frame');
								resetFramingOptions();
							}
							updateFinalPrice();
						})

						function hideShowFramingOptions() {
						var $frameSelect = $('select#frameMaterial');
						var currentValue = $frameSelect.val();

						$frameSelect.empty();

						allFrameOptions.each(function() {
							var $option = $(this);
							if ($option.attr('data-size') == activeSize) {
							$frameSelect.append($option.clone());
							}
						});

						if ($frameSelect.find('option[value="' + currentValue + '"]').length) {
							$frameSelect.val(currentValue);
						} else if ($frameSelect.find('option:first').length) {
							$frameSelect.val($frameSelect.find('option:first').val());
						}
						}

						$('#addPaspartu').on('change', function() {
							if ($('#addPaspartu').is(':checked')) {
								var paspartuOption = $('ul#paspartu').find('li[data-size='+activeSize+']')[0];
								$('input[name=paspartuID]').val($(paspartuOption).attr('data-value'));
								// $('#paspartuPrice').removeClass('hidden').find('span').text(Shopify.formatMoney($(paspartuOption).attr('data-price'), '{{amount_no_decimals}} ש"ח'));
								$('#finalPrice').attr('data-paspartu', Shopify.formatMoney($(paspartuOption).attr('data-price'), '{{amount_no_decimals}}'));
							} else {
								$('input[name=paspartuID]').val('');
								// $('#paspartuPrice').addClass('hidden').find('span').text('');
								$('#finalPrice').attr('data-paspartu', '0');
							}
							updateFinalPrice();
						});

						$('select#frameMaterial').on('change', function() {
                         var selectedOption = $('select#frameMaterial option:selected');

                         $('input[name=frameID]').val($(selectedOption).val());
 						 $('#finalPrice').attr('data-framing', Shopify.formatMoney($(selectedOption).attr('data-price'), '{{amount_no_decimals}}'));
 						 updateFinalPrice();

 						 // jump to matching mockup image by alt text: mockup|<frame name>
 						 var frameName = $(selectedOption).text().trim();
 						 var targetAlt = 'mockup|' + frameName;

						 var $thumb = $('.pager.custom a img[alt="' + targetAlt + '"]').first();
 						 if ($thumb.length) {
   						 	$thumb.closest('a').trigger('click');
 						 }
						});

						/** 
						 * Acutal add to cart 5070
						 */
						$('#singleAddToCart').on('click', function(e) {
							var button = $(this);
							e.preventDefault();
							var id = $('input[name=id]').val(),
								productTitle = $(button).attr('data-title') +', גודל: '+activeSize,
								items = [];

							if (id && id != '') {
								items.push({ quantity: 1, id: id});
							}
							
							var frameID = $('input[name=frameID]').val();
							if (frameID != ''){ 
								items.push({ quantity: 1, id: frameID, properties: { 'מסגור עבור': productTitle }});
							}

							var paspartuID = $('input[name=paspartuID]').val()
							if (paspartuID && paspartuID != ''){
								items.push({ quantity: 1, id: paspartuID, properties: { 'פספרטו עבור': productTitle }});
							}

							if (id && id != '') { 
								$(button).text('מוסיף לסל...');
								
								$.ajax({
									type: 'POST', 
									url: '/cart/add.js',
									dataType: 'json', 
									data: { items: items },
									success: function() {
										$(button).text('המוצר נוסף לסל הקניות');
										setTimeout(function() {
											$('a[data-panel=cart]').click();
										}, 1000);
									},
									error: function(response) {
										$(button).text('המוצר לא זמין');
									}
								}).always(function(){
									window.refreshCart();
									setTimeout(function() {
										$(button).text('הוספה לסל');
									}, 1500);
								});
							} else { 
								
							}
						});

					}
				},
				miscellaneous: function () {
					if (module_featured.length) {
						module_featured.each(function () {
							if ($(this).children().length > 1) {
								$(this).owlLayout().children('.inner').owlCarousel({
									loop: true,
									nav: true,
									dots: false,
									autoHeight: true,
									lazyLoad: true,
									margin: 0,
									items: 1,
									rtl: true,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
									}
								});
							}
						});
					}
					if (module_list_slider.length) {
						module_list_slider.each(function () {
							var sl = $(this).children('ul'),
								nv = $(this).children('nav'),
								ow;
							sl.find('li').each(function (i) {
								$(this).attr('data-no', i);
								i + 1;
							});
							if (sl.children().length > 1) {
								$(this).addClass('has-slider');
								sl.owlLayout();
								ow = sl.children('.inner').owlCarousel({
									loop: true,
									nav: true,
									dots: false,
									autoHeight: true,
									lazyLoad: true,
									margin: 34,
									items: 1,
									rtl: true,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
										$(this.$element).parents('.has-slider').find('[data-slide-index]').parent().removeClass('active').children('[data-slide-index="' + $(this.$element).find('.owl-item.active [data-no]').attr('data-no') + '"]').parent().addClass('active');
									}
								});
							}
							nv.find('a[data-slide-index]').on('click', function () {
								ow.trigger('to.owl.carousel', parseInt($(this).attr('data-slide-index')));
								nv.find('li.active').removeClass('active');
								$(this).closest('li').addClass('active');
								return false;
							});
						});
					}
					if (list_product.length) {
						list_product.each(function () {
							if ($(this).children().length > 1) {
								$(this).owlLayout();
								$(this).append('<ul class="pager custom"></ul>').children('.inner').children().each(function (i) {
									$(this).find('img:first').clone().wrap('<a href="./" role="button" data-slide-index="' + i + '"></a>').parent().appendTo($(this).parents('.is-slider:first').find('.pager.custom'));
								});
								$(this).children('.inner').owlCarousel({
									nav: false,
									dots: false,
									autoHeight: true,
									loop: false,
									items: 1,
									margin: 0,
									rtl: true,
									onInitialized: function () {
										$(this.$element).owlSemantic();
                                        setTimeout(function() {
                                          $(window).trigger('resize');
                                        }, 10);
									},
									onTranslated: function (event) {
										$(this.$element).owlSemantic();
										$(this.$element).parents('.is-slider').find('[data-slide-index]').parent().removeClass('active').children('[data-slide-index="' + event.item.index + '"]').parent().addClass('active');
									}
								});
								$(this).find('a[data-slide-index]').wrap('<li></li>').each(function () {
									if ($(this).parent().is(':first-child')) {
										$(this).addClass('current').attr('aria-pressed', true);
									} else {
										$(this).attr('aria-pressed', false);
									}
								}).on('click', function () {
									var n = $(this),
										f = n.parents('.is-slider:first');
									f.find('.pager a[data-slide-index]').each(function (k, v) {
										if ((v = $(v)).is('[data-slide-index="' + n.attr('data-slide-index') + '"]')) {
											v.attr('aria-pressed', true).addClass('current');
										} else {
											v.attr('aria-pressed', false).removeClass('current');
										}
									});
									f.find('.owl-carousel:first').trigger('to.owl.carousel', n.attr('data-slide-index'));
									return false;
								});
							}
						});
					}
                 
					if (list_collection.length) {
						list_collection.each(function () {
                          const $this = $(this);
							if ($(this).closest('.module-artists').length && !$(this).closest('#nav').length) {
								if ($(this).children().length > 1) {
                                  const isWithSidebar = $this.data('layout') === true || $this.data('layout') === 'true';
                                  const itemsCount = isWithSidebar ? 3 : 4;
                                  
                                  const $sidebar = $this.closest('article').find('.sidebar_hide');
                                  if (isWithSidebar) {
                                  $sidebar.show(); 
                                  } else {
                                  $sidebar.hide(); 
                                  }

                                  
									$(this).owlLayout().children('.inner').owlCarousel({
										loop: true,
										nav: true,
										dots: false,
										autoHeight: true,
										lazyLoad: true,
										margin: 56,
										items: 3,
										rtl: true,
										onInitialized: function () {
											$(this.$element).owlSemantic();
										},
										onTranslated: function () {
											$(this.$element).owlSemantic();
										},
										responsive: {
											0: {
												margin: 24,
												items: 1,
												// mouseDrag: true,
												// touchDrag: true,
												// pullDrag: true,
												// freeDrag: true
											},
											761: {
												margin: 36,
												items: 2,
												mouseDrag: false,
												touchDrag: false,
												pullDrag: false,
												freeDrag: false
											},
											1001: {
												margin: 36,
												items: 3,
												mouseDrag: false,
												touchDrag: false,
												pullDrag: false,
												freeDrag: false
											},
											1201: {
												margin: 56,
        										items: itemsCount,
                                        		mouseDrag: false,
												touchDrag: false,
												pullDrag: false,
												freeDrag: false
											}
										}
									});
								}
							}
							// if (!$(this).closest('.module-artists').length) {
							// 	$(this).isotope({
							// 		layoutMode: 'masonry',
							// 		originLeft: false
							// 	});
							// }
						});
					}
					if (list_collection.length) {
						list_collection.each(function () {
							if ($(this).hasClass('isotope')) { 
								var $grid = $(this).isotope({
									layoutMode: 'masonry',
									originLeft: false
								});
								$grid.imagesLoaded().progress( function() {
									$grid.isotope('layout');
								});
							}
						});
					}
					if (list_collections.length) {
						list_collections.each(function () {
							var $grid = $(this).isotope({
								layoutMode: 'masonry',
								originLeft: false
							});
							$grid.imagesLoaded().progress( function() {
								$grid.isotope('layout');
							});
						});
					}
				}
			}
		};
	setTimeout(function () {
		Default.utils.layout();
		Default.utils.shopify();
		Default.utils.mails();
		Default.utils.date;
		Default.utils.mobile();
		Default.utils.miscellaneous();
		Default.utils.done();
	}, 0);
});

/*!*/

document.querySelector(':root').style.setProperty('--scrollbar_width', window.innerWidth - document.documentElement.clientWidth + 'px');
